import React from 'react'

const LoaderCard = () => {
  return (
    <>
    <div className="loader  position-absolute  top-50  start-50  translate-middle  " >
    <div className="spinner center bg-transparent m-0">
   <div  className='spinner-bottom'>
   <div className="spinner-blade"></div>
    <div className="spinner-blade"></div>
    <div className="spinner-blade"></div>
    <div className="spinner-blade"></div>
    <div className="spinner-blade"></div>
    <div className="spinner-blade"></div>
    <div className="spinner-blade"></div>
    <div className="spinner-blade"></div>
    <div className="spinner-blade"></div>
    <div className="spinner-blade"></div>
    <div className="spinner-blade"></div>
    <div className="spinner-blade"></div>
   </div>
</div>
</div>
    </>
  )
}

export default LoaderCard